<ul *ngIf="isSmallerThanIpad() && isShow" [@slideInOut] id="footnote" class="nav nav-classic nav-justified bg-alt">
  <li class="nav-item pt-2" style="width: {{getClientWidth()}}">
    <button (click)="toggleDisplay()" class="btn btn-link" style="top: 10px">
      <app-fa-icon iconName="times" classes="text-fg right-0 mr-2 position-absolute"></app-fa-icon>
    </button>
    <p class="text-fg mt-2 mx-7">{{descText}}</p>
    <app-kopa-button link="{{url}}" color="{{buttonColor}}" classes="mb-3 transition-3d-hover btn-wide" text="{{buttonText}}"></app-kopa-button>
  </li>
</ul>
